import React, { useEffect, useState } from "react";

import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    useTheme,
    useMediaQuery
} from "@material-ui/core";

import Input from "@material-ui/core/Input";
import { observer } from "mobx-react";
import { changeEventHandlerDecorator } from "../../../../../common/libs";

import { Button, FormControl, TextField, Typography } from "../../../../../common/components/libs";

import { CouponsFormType } from "../../../store/forms";
import { CouponData, CouponType } from "../../../../../services/coupons/models";
import { useStores } from "../../../../../hooks";
import { DatePicker, DateTimePicker } from "@material-ui/pickers";
import { SnackbarType } from "../../../../../stores/common";
import moment from "moment";
import {Trans, useTranslation} from "react-i18next";


const CreateCouponForm = () => {
    const [code, setCode] = useState("");
    const [type, setType] = useState(CouponType.percentage);
    const [discount, setDiscount] = useState(1);
    const [totalUsagesLimit, setTotalUsagesLimit] = useState(1);
    const [valueDateFrom, setValueDateFrom] = useState(new Date());
    let date = new Date();
    const [valueDateTo, setValueDateTo] = useState(new Date(date.setMonth(date.getMonth() + 1)));


    const { couponsStore, generalStore, constantsStore } = useStores();
    const forms = couponsStore.forms;
    const { open, current } = forms.forms[CouponsFormType.createCoupon];

    const {i18n, t} = useTranslation(["general", "coupons"]);
    const locale = generalStore.locale.id
    const formatter = constantsStore.getCurrencyFormatter("RUB");

    let title = current ? t("coupons:couponForm.editCoupon") : t("coupons:couponForm.createCoupon");

    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));


    useEffect(() => {
        if (current) {
            setCode(current.data.code);
            setType(current.data.type);
            setTotalUsagesLimit(current.data.totalUsagesLimit);
            setValueDateFrom(current.data.startDate);
            setValueDateTo(current.data.endDate);
            if (current.data.type === CouponType.percentage) {
                setDiscount(current.data.discountPercent);
            } else {
                setDiscount(current.data.discountAmount.amount);
            }
        }else{
            setCode("");
            setType(CouponType.percentage);
            setTotalUsagesLimit(1);
            setValueDateFrom(moment().toDate());
            setValueDateTo(moment().add(1, 'month').toDate());
            setDiscount(100)
        }
    }, [current]);

    const setDiscountWrapper = (value: number) => {
        if(type === CouponType.fixedAmount){
            setDiscount(formatter.toSend(value))
        }else if(type === CouponType.percentage){
            setDiscount(value)
        }
    }

    const getDiscountFormatted = () => {
        if(type === CouponType.fixedAmount){
            return formatter.toShow(discount, true, true)
        }else if(type === CouponType.percentage){
            return discount;
        }
    }



    const closeForm = () => {
        forms.closeForm(CouponsFormType.createCoupon);
        setCode("");
        setType(CouponType.percentage);
        setDiscount(1);
        setTotalUsagesLimit(1);
        setValueDateFrom(new Date());
        date = new Date();
        setValueDateTo(new Date(date.setMonth(date.getMonth() + 1)));
    };

    const handleSubmit = async () => {
        let data: CouponData;
        if (type === CouponType.fixedAmount) {
            data = {
                code: code,
                endDate: valueDateTo,
                startDate: valueDateFrom,
                totalUsagesLimit: totalUsagesLimit,
                type: type,
                discountAmount: {
                    amount: discount,
                    currencyId: generalStore.currency.id
                }
            };
        } else if (type === CouponType.percentage) {
            data  = {
                code: code,
                endDate: valueDateTo,
                startDate: valueDateFrom,
                totalUsagesLimit: totalUsagesLimit,
                type: type,
                discountPercent: discount
            };
        }

        if(current){
            couponsStore.updateCoupon(data, current.id).then(() =>
                generalStore.showSnackbar({
                    title: t("coupons:couponForm.labelOfUpdating"),
                    type: SnackbarType.success
                })
            );
        }else{
            couponsStore.createCoupon(data).then(() => {
                generalStore.showSnackbar({
                    title: t("coupons:couponForm.labelOfCreation"),
                    type: SnackbarType.success
                })
            })
        }

    };

    const generateCoupon = () => {
        const generatedCode = (Math.floor(Math.random() * (999999 - 100000) + 100000)).toString();
        setCode(generatedCode);
    };


    return (
        <Dialog
            open={open}
            onClose={closeForm}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"sm"}
            fullScreen={!isSm}
        >
            <DialogTitle id="form-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <form autoComplete="off">
                    <FormControl fullWidth margin={"normal"}>
                        <InputLabel htmlFor="code">{t("coupons:coupon")}</InputLabel>
                        <Input
                            value={code}
                            onChange={changeEventHandlerDecorator(setCode)}
                        />
                        <Button color="primary"
                                style={{ textAlign: "left", maxWidth: 210, marginTop: 10 }}
                                onClick={generateCoupon}
                        >
                            {t("coupons:couponForm.generateCoupon")}
                        </Button>
                    </FormControl>

                    <FormControl fullWidth margin={"normal"}>
                        <InputLabel htmlFor="menuCategorySelect">{t("coupons:typeCoupon")}</InputLabel>
                        <Select
                            value={type}
                            onChange={changeEventHandlerDecorator(setType)}
                        >
                            <MenuItem value={CouponType.percentage}>{t("coupons:discountInPercentages")}</MenuItem>
                            <MenuItem value={CouponType.fixedAmount}>{t("coupons:discountInCurrency")}</MenuItem>
                        </Select>
                    </FormControl>

                    <FormControl fullWidth margin={"normal"}>
                        <TextField
                            id="discountPercent"
                            label={t("coupons:discount")}
                            type="number"
                            value={getDiscountFormatted()}
                            onChange={changeEventHandlerDecorator(setDiscountWrapper)}
                            InputLabelProps={{
                                shrink: true
                            }}
                            InputProps={{
                                endAdornment: <InputAdornment
                                    position="end">{type === "Percentage" ? "%" : generalStore.currency.currencyShortName[locale]}</InputAdornment>
                            }}
                            inputProps={{
                                min: 1,
                                max: 100
                            }}

                            variant="standard"
                        />
                    </FormControl>

                    <FormControl fullWidth margin={"normal"}>
                        <TextField
                            id="totalUsagesLimit"
                            label={t("coupons:numberOfUses")}
                            type="number"
                            value={totalUsagesLimit}
                            onChange={changeEventHandlerDecorator(setTotalUsagesLimit)}
                            InputLabelProps={{
                                shrink: true
                            }}
                            inputProps={{ min: 1 }}
                            variant="standard"
                        />
                    </FormControl>

                    <FormControl fullWidth margin={"normal"}>
                        <Typography variant={"body1"} mt={4} color={"textSecondary"}>
                            {t("coupons:validity")}
                        </Typography>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <Grid container spacing={6}>
                                <Grid item>
                                    <FormControl>
                                        <DatePicker
                                            label={t("general:from")}
                                            value={valueDateFrom}
                                            onChange={(value: Date) => {
                                                setValueDateFrom(value);
                                            }}
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid item>
                                    <FormControl>
                                        <DatePicker
                                            label={t("general:to")}
                                            value={valueDateTo}
                                            onChange={(value: Date) => {
                                                setValueDateTo(value);
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </div>
                    </FormControl>
                </form>
            </DialogContent>

            <DialogActions>
                <Button onClick={closeForm} color="primary">
                    {t("general:cancel")}
                </Button>
                <Button color="primary" onClick={handleSubmit} variant={"contained"}>
                    {current? t("general:edit"): t("general:add")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default observer(CreateCouponForm);
